export default __webpack_public_path__ + "static/media/casadascriancas.25c14f7f.jpg";